import { lmsClient } from "api";

const LoanVAService = {};

LoanVAService.getLoanVAList = function (data) {
  const params = new URLSearchParams();
  params.append("applicationid", data?.applicationid || "");
  params.append("loanno", data?.loanno || "");
  params.append("branchid", data?.branchid || "");
  params.append("customerName", data?.customerName || "");
  params.append("bankid", data?.bankid || "");
  params.append("vabinno", data?.vabinno || "");
  params.append(
    "hasVirtualAccount",
    data?.hasVirtualAccount === undefined || data?.hasVirtualAccount === null
      ? ""
      : data.hasVirtualAccount
  );
  params.append("startDate", data?.startDate || "");
  params.append("endDate", data?.endDate || "");

  return lmsClient({
    url: `/lm_loan_va/search?${params.toString()}`,
    method: "get",
  });
};

LoanVAService.addLoanVA = function (data) {
  return lmsClient({
    url: "/lm_loan_va/add",
    method: "post",
    data,
  });
};

export default LoanVAService;
